const CatalogModel = {};

CatalogModel.CATALOG_BLOCK_TYPES = {
  OFFERS: 1,
  BANNER: 2,
  CUSTOM_ORDER_BANNER: 3,
  CATALOG: 4,
};

CatalogModel.CATALOG_BLOCK_TYPES_NAMES = {
  [CatalogModel.CATALOG_BLOCK_TYPES.OFFERS]: 'Offers module',
  [CatalogModel.CATALOG_BLOCK_TYPES.BANNER]: 'Banner module',
  [CatalogModel.CATALOG_BLOCK_TYPES.CUSTOM_ORDER_BANNER]: 'Custom order banner',
  [CatalogModel.CATALOG_BLOCK_TYPES.CATALOG]: 'Catalog module',
};

export default CatalogModel;
